// extracted by mini-css-extract-plugin
export default {"LabeledIconButton":"labeledImgLink_LabeledIconButton__TTmm6","img_anime":"labeledImgLink_img_anime__rePFD","link":"labeledImgLink_link__szh4c","label":"labeledImgLink_label__E3KVn"};